var map = {
	"./ambrosia.png": 646,
	"./chthonic keys.png": 486,
	"./darkness.png": 954,
	"./diamond.png": 345,
	"./gemstones.png": 351,
	"./nectar.png": 706,
	"./titan blood.png": 328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;